import { Controller } from "@hotwired/stimulus"

// Contrôleur Stimulus pour partager une page (Web Share API) avec fallback copie presse-papiers
//
// Usages:
// - Partager la page courante:
//   data-controller="share"
//   data-action="click->share#share"
//   data-share-title-value="Mon titre"
//
// - Copier une URL spécifique:
//   data-controller="share"
//   data-action="click->share#copy"
//   data-share-url-value="https://example.com"
export default class extends Controller {
  static values = {
    title: String,
    url: String,
    copiedText: { type: String, default: "✓ Lien copié !" }
  }

  share(event) {
    event?.preventDefault()

    const title = this.hasTitleValue ? this.titleValue : document.title
    const url = this.hasUrlValue ? this.urlValue : window.location.href

    if (navigator.share) {
      navigator.share({ title, url }).catch(() => {
        // Si l'utilisateur annule ou si le share échoue, on retombe sur la copie
        this.copyToClipboard(url)
      })
      return
    }

    this.copyToClipboard(url)
  }

  copy(event) {
    event?.preventDefault()
    const url = this.hasUrlValue ? this.urlValue : window.location.href
    this.copyToClipboard(url)
  }

  async copyToClipboard(text) {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text)
      } else {
        this.fallbackCopy(text)
      }
      this.showCopyFeedback(this.element)
    } catch (err) {
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.top = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
  }

  showCopyFeedback(element) {
    const originalHtml = element.dataset.shareOriginalHtml || element.innerHTML
    element.dataset.shareOriginalHtml = originalHtml

    // On remplace temporairement le contenu (sans perdre définitivement le SVG / markup)
    element.innerHTML = this.copiedTextValue
    element.classList.add("text-green-600")

    setTimeout(() => {
      element.innerHTML = element.dataset.shareOriginalHtml || originalHtml
      element.classList.remove("text-green-600")
    }, 2000)
  }
}

